module.exports = __webpack_public_path__ + "img/Drive shaft boots.775d934a.jpg";